<div class="search-results" data-testid="lot-search-container">
  <ng-template #scheduleAction let-result="result">
    @if (isAddingJob(result)) {
      <span class="btn add-lot-btn loading" data-testid="lot-search-btn-adding">
        <i class="pi pi-sync pi-spin"></i>Adding to Schedule
      </span>
    } @else {
      <span
        class="btn add-lot-btn"
        (click)="addJob(result)"
        data-testid="lot-search-btn-add-to-schedule">
        <i class="pi pi-plus-circle"></i>Add to Schedule
      </span>
    }
  </ng-template>

  @if (fromCMSearch == false) {
    <div class="search-results-header" data-testid="lot-search-header">
      <img
        class="back-arrow"
        src="assets/icons/leftArrow.svg"
        alt="Back"
        (click)="backToCommunitySearch()"
        data-testid="lot-search-btn-back" />
      <span class="nav-hd-bold">Find a lot</span>
      <online-indicator></online-indicator>
    </div>
  }

  <div class="search-results-parameters">
    @if (fromCMSearch == false) {
      <div class="parameter-row">
        <span class="parameter-label">Community:</span>
        <span class="parameter-value">{{ selectedCommunity()?.salesCommunityName }}</span>
      </div>

      <div
        class="community-input"
        data-testid="community-dropdown"
        (click)="searchCommunityHandler.emit()">
        <span class="community-name">
          {{ selectedCommunity()?.salesCommunityName ?? "Choose a Community" }}
        </span>
        <i class="pi pi-chevron-down"></i>
      </div>
    }

    <div class="search-input-group">
      <div class="search-input-wrapper">
        <input
          #searchInput
          class="search-term-input"
          data-testid="search-term-input"
          type="search"
          pInputText
          placeholder="Enter address/lot#"
          aria-label="Search by address or lot number"
          [(ngModel)]="searchTerm"
          (keyup.enter)="executeSearch()" />

        <div class="search-button-inside search-button-host">
          <app-svg-search-button
            data-testid="inline-search"
            (buttonClick)="executeSearch()">
          </app-svg-search-button>
        </div>
      </div>

      @if (fromCMSearch) {
        <button
          type="button"
          class="text-link-button"
          (click)="executeSearchAll()"
          data-testid="lot-search-btn-show-all">
          Show All Lots
        </button>
      }
    </div>
  </div>

  @if (isSearching) {
    <div class="spinner-container" data-testid="lot-search-container-loading">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  } @else {
    <div class="results-container" [class.has-done-footer]="fromCMSearch" data-testid="lot-search-results-container">
      <div class="results-count body-md-medium" data-testid="lot-search-text-results-count">
        {{ results().length }}
      </div>

      @if (results().length > 0) {
        <div class="results-list" data-testid="lot-search-list">
          @for (lotSearchResult of results(); track lotSearchResult.externalLotId) {
            <div class="result-item" data-testid="lot-search-item">
              <div class="lot-address">
                <span>{{ lotSearchResult.streetAddress }}</span>
              </div>

              <div class="lot-secondary-info">
                <div>
                  <div>
                    <span>Lot {{ lotSearchResult.lotBlock }}</span>
                  </div>

                  <div class="lot-date-ccm">
                    <span class="no-wrap">{{ lotSearchResult.jobScheduleDate | ordinalDate }}</span>
                    <span class="no-wrap">|</span>
                    <span>{{ lotSearchResult.customerCareManagerName }}</span>
                  </div>

                  @switch (lotSearchResult.lotStatus) {
                    @case (LotStatus.Overdue) {
                      <div>
                        <p-tag
                          class="status-tag"
                          severity="info"
                          [rounded]="true"
                          icon="pi pi-lock"
                          [value]="fromCMSearch ? 'Last Inspection 7+ days past due' : 'Confirmation 7+ days past due'"
                          data-testid="lot-search-badge-overdue">
                        </p-tag>
                      </div>
                    }

                    @case (LotStatus.InUserSchedule) {
                      <div>
                        <p-tag
                          class="status-tag"
                          severity="success"
                          [rounded]="true"
                          icon="pi pi-check"
                          value="Added to Schedule"
                          data-testid="lot-search-badge-in-schedule">
                        </p-tag>
                      </div>
                    }

                    @case (LotStatus.Archived) {
                      <div>
                        <p-tag
                          class="status-tag"
                          severity="secondary"
                          [rounded]="true"
                          icon="pi pi-inbox"
                          value="Archived"
                          data-testid="lot-search-badge-archived">
                        </p-tag>
                      </div>
                    }
                  }
                </div>

                @switch (lotSearchResult.lotStatus) {
                  @case (LotStatus.Overdue) {
                    <div class="lot-overdue-message" data-testid="lot-search-text-overdue-message">
                      The date must be updated in the Construction Portal to add this to your schedule.
                    </div>
                  }

                  @case (LotStatus.Completed) {
                    @if (canAddCompletedLot(lotSearchResult)) {
                      <ng-container
                        [ngTemplateOutlet]="scheduleAction"
                        [ngTemplateOutletContext]="{ result: lotSearchResult }">
                      </ng-container>
                    } @else {
                      <a
                        class="btn view-report-btn"
                        [href]="'/reports/' + lotSearchResult.externalLotId + '?reportStep=BQ7'"
                        target="_blank"
                        style="text-decoration: none;"
                        data-testid="lot-search-link-view-report">
                        <i class="pi pi-external-link"></i>View Report
                      </a>
                    }
                  }

                  @case (LotStatus.Scheduleable) {
                    <ng-container
                      [ngTemplateOutlet]="scheduleAction"
                      [ngTemplateOutletContext]="{ result: lotSearchResult }">
                    </ng-container>
                  }

                  @case (LotStatus.Archived) {
                    @if (unarchivingLots().includes(lotSearchResult.id)) {
                      <span class="btn add-lot-btn loading" data-testid="lot-search-btn-unarchiving">
                        <i class="pi pi-sync pi-spin"></i>Restoring...
                      </span>
                    } @else {
                      <span
                        class="btn add-lot-btn"
                        (click)="unarchiveLot(lotSearchResult.id)"
                        data-testid="lot-search-btn-unarchive">
                        <i class="pi pi-undo"></i>Unarchive Lot
                      </span>
                    }
                  }
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="no-results" data-testid="lot-search-container-no-results">
          <img class="search-icon" src="assets/icons/no-search-results.svg" alt="No Results" />
          <span class="no-results-header">No properties found</span>
          <span class="body-md-regular">Update your search filters to try again</span>
        </div>
      }
    </div>

    @if (fromCMSearch) {
      <div class="done-footer">
        <button
          type="button"
          class="done-button"
          data-testid="cm-search-done-button"
          (click)="emitDone()">
          Done
        </button>
      </div>
    }
  }
</div>
